import BackButton from "../../Components/BackButton";
import { DashboardLayout } from "../../Layout/DashboardLayout";
import LinkTypeComponentAddEdit from "./LinkTypeComponentAddEdit";

const ScofaDashboardLinkTypeManagementAdd = () => {
    return (
        <>
            <LinkTypeComponentAddEdit
                // name={"Dashboard Link Type"}
                baseAPI={"/api/user/dashboard-link-types/"}
            />
        </>
    );
};

export default ScofaDashboardLinkTypeManagementAdd;